import once from 'lodash/once';
import UAparser from 'ua-parser-js';

export const getParser = once(() => new UAparser());
